module.exports = "//cdn.livechat-static.com/webapp/img/icon-livechat.svg?d76a06ea6bcdff21b398859d29e55218";